export const TOKEN_KEY = "token";
export const isAuthenticated = () => Boolean(localStorage.getItem(TOKEN_KEY) || false)
export const getToken = () => localStorage.getItem(TOKEN_KEY)
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token)
export const removeToken = async() => localStorage.removeItem(TOKEN_KEY)
